import React from 'react';
import { useStore } from '../../../store/rootStore';
import { observer } from 'mobx-react';
import ChatStatusMenu from './atoms/ChatStatusMenu';
import AccountSection from './atoms/AccountSection';
import MobileTopBar from './atoms/MobileTopBar';
import classNames from 'classnames';
import styles from './TopContent.module.scss';
const TopContent = () => {
    const { loginStore, activeChatStore } = useStore();
    const { userDetails } = loginStore;
    const isChatOpen = !!activeChatStore.chat;
    return (React.createElement("div", { className: classNames(styles.container, {
            [styles.chatOpen]: isChatOpen,
        }) },
        React.createElement(MobileTopBar, null),
        React.createElement(ChatStatusMenu, null),
        React.createElement(AccountSection, { userName: (userDetails === null || userDetails === void 0 ? void 0 : userDetails.displayName) || '' })));
};
export default observer(TopContent);
